module.exports = __webpack_public_path__ + "static/media/imoveisParaVenda.cd0085af.jpg";